import React from "react";

import PropTypes from "prop-types";

import SVGIcon from "~components/utils/svg_icon/svg_icon";

import { clearButtonStyle } from "./input_clear_button.module.scss";

export default function InputClearButton({ onClick, iconSize }) {
  return (
    <button className={clearButtonStyle} type="button" onClick={onClick}>
      <SVGIcon
        icon="icon_clear"
        width={iconSize}
        height={iconSize}
        color="cloudBurst50"
      />
    </button>
  );
}

InputClearButton.propTypes = {
  onClick: PropTypes.func,
  iconSize: PropTypes.number,
};

InputClearButton.defaultProps = {
  onClick: () => {},
  iconSize: 20,
};
